import remixTranslations from 'shared/translations/remix.json'

export const REMIX_DEFAULT_TEXTS = Object.keys(remixTranslations).reduce((acc, key) => ({ ...acc, [key]: {} }), {})
